import FormsListSingle from "./SBIAOF3/FormsListSingle";
import Single from "./SBIAOF3/Single";
import FormsListJoint from "./SBIAOF3/FormsListJoint";
import Joint from "./SBIAOF3/Joint";
import FormsListSBIAOF4 from "./SBI_AOF4/FormList";
import SBIAOF4 from "./SBI_AOF4/SBI_AOF4";
import FormsListCurrent1 from "./SBI_CA1/FormsListCurrent";
import Current1 from "./SBI_CA1/Current";
import FormsListCurrent2 from "./SBI_CA2/FormsListCurrent";
import Current2 from "./SBI_CA2/Current";
import FormsListCurrentSP from "./SBI_CA_SP/FormsListCurrent";
import CurrentSP from "./SBI_CA_SP/Current";
import FormsListKYC3 from "./SBIKYC3/FormsListKYC3";
import SBIKYC3 from "./SBIKYC3/KYC3";
import FormsListPPF from "./SBIPPF/FormsListPPF";
import SBIPPF from "./SBIPPF/PPF";
import FormsListSukanya3 from "./SBISSA3/FormsListSukanya3";
import Sukanya3 from "./SBISSA3/Sukanya3";
import FormsListAgriLoan from "./SBI_AGRI_LOAN/FormsList";
import AgriLoan from "./SBI_AGRI_LOAN/AgriLoan";

const modifyMyFormRoutes = [
  {
    path: "/ModifyMyForm/SBIAOF3/FormsListSingle",
    element: <FormsListSingle />,
  },

  {
    path: "/ModifyMyForm/SBIAOF3/Single",
    element: <Single />,
  },

  {
    path: "/ModifyMyForm/SBIAOF3/FormsListJoint",
    element: <FormsListJoint />,
  },

  {
    path: "/ModifyMyForm/SBIAOF3/Joint",
    element: <Joint />,
  },  

    {
    path: "/ModifyMyForm/SBI_AOF4/FormsList",
    element: <FormsListSBIAOF4 />,
  },

  {
    path: "/ModifyMyForm/SBI_AOF4/SBI_AOF4",
    element: <SBIAOF4 />,
  }, 

  {
    path: "/ModifyMyForm/SBI_CA1/FormsListCurrent",
    element: <FormsListCurrent1 />,
  },

  {
    path: "/ModifyMyForm/SBI_CA1/Current",
    element: <Current1 />,
  },

  {
    path: "/ModifyMyForm/SBI_CA2/FormsListCurrent",
    element: <FormsListCurrent2 />,
  },

  {
    path: "/ModifyMyForm/SBI_CA2/Current",
    element: <Current2 />,
  },

  {
    path: "/ModifyMyForm/SBI_CA_SP/FormsListCurrent",
    element: <FormsListCurrentSP />,
  },

  {
    path: "/ModifyMyForm/SBI_CA_SP/Current",
    element: <CurrentSP />,
  },  

  {
    path: "/ModifyMyForm/SBISSA3/FormsListSukanya3",
    element: <FormsListSukanya3 />,
  },

  {
    path: "/ModifyMyForm/SBISSA3/Sukanya3",
    element: <Sukanya3 />,
  },   

  {
    path: "/ModifyMyForm/SBIPPF/FormsListPPF",
    element: <FormsListPPF />,
  },

  {
    path: "/ModifyMyForm/SBIPPF/PPF",
    element: <SBIPPF />,
  },

  {
    path: "/ModifyMyForm/SBIKYC3/FormsListKYC3",
    element: <FormsListKYC3 />,
  },

  {
    path: "/ModifyMyForm/SBIKYC3/KYC3",
    element: <SBIKYC3 />,
  },   

  {
    path: "/ModifyMyForm/SBI_AGRI_LOAN/FormsList",
    element: <FormsListAgriLoan />,
  },

  {
    path: "/ModifyMyForm/SBI_AGRI_LOAN/AgriLoan",
    element: <AgriLoan />,
  },    


];

export default modifyMyFormRoutes;